import React from 'react';
import { LessonHomeworkSubmissionShowView } from '../../../types/lesson_homework_submissions';
import './reviewInstruction.module.scss';
import { UserId } from '../../../../mainv2/types/user';
import { ExamPracticalSectionSubmissionShowView } from '../../../types/exam_sections';

const Message = ({ viewerId, submission }) => {
  if (!submission.reviewer) {
    return <span>担当者の決定後にフィードバックを行うことができます</span>;
  }
  if (submission.reviewer.id !== viewerId) {
    return <span>自分の担当の提出のみフィードバックを行うことができます</span>;
  }
  return <span>フィードバックコメントの記載をお願いします</span>;
};
type Props = {
  viewerId: UserId;
  submission: LessonHomeworkSubmissionShowView | ExamPracticalSectionSubmissionShowView;
};

export const ReviewInstruction = ({ viewerId, submission }: Props) => {
  if (submission.review_completed_at) {
    return null;
  }
  return (
    <div styleName="review-instruction" id="review-instruction">
      <Message submission={submission} viewerId={viewerId} />
    </div>
  );
};
